/**
 * Creates containers in header for the sticky planboxes.
 *
 * @package Qustodio\Theme
 */

import header from '../../../template-parts/header';

const stickyPlanboxContainer = () => {
  let planboxContainerElement;
  let planboxDesktopElement;
  let planboxMobileElement;

  const createPlanboxContainers = () => {
    planboxContainerElement = document.createElement('div');
    planboxContainerElement.classList.add(
      'js-sticky-planboxes__header-container',
      'exp-sticky-planbox__header-container',
    );

    planboxDesktopElement = document.createElement('table');
    planboxDesktopElement.classList.add(
      'qusd-container',
      'qusd-exp-planbox-sticky__wrapper',
      'qusd-exp-planbox-sticky__wrapper--desktop',
    );

    planboxMobileElement = document.createElement('table');
    planboxMobileElement.classList.add(
      'qusd-exp-planbox-sticky__wrapper',
      'qusd-exp-planbox-sticky__wrapper--mobile',
    );

    // Creating sticky planbox containers.
    const mobilePlanboxContainerElement = planboxContainerElement.cloneNode();
    const desktopPlanboxContainerElement = planboxContainerElement.cloneNode();
    mobilePlanboxContainerElement.appendChild(planboxMobileElement);
    desktopPlanboxContainerElement.appendChild(planboxDesktopElement);
    // Insert sticky planbox containers in parent elements.
    header.getMobileStickyContainer().appendChild(mobilePlanboxContainerElement);
    header.getDesktopStickyContainer().appendChild(desktopPlanboxContainerElement);
  };

  const init = () => {
    createPlanboxContainers();
  };

  const getContainerDesktop = () => planboxDesktopElement;

  const getContainerMobile = () => planboxMobileElement;

  return {
    init,
    getContainerDesktop,
    getContainerMobile,
  };
};

export default stickyPlanboxContainer();
